import React from 'react';
import './AntDesign.css'; // Create this CSS file
import { useLanguage } from '../context/LanguageContext'; 

const AntDesign = () => {
  const { language } = useLanguage();
  const stats = [
    { value: '8', label: 'Clinics', label_ml: "ക്ലിനിക്കുകൾ" },
    { value: '100+', label: 'Volunteers', label_ml: "വളണ്ടിയർമാർ" },
    { value: '500+', label: 'Patients', label_ml: "രോഗികൾ" },
    { value: '30+', label: 'Health Workers', label_ml: "ആരോഗ്യ പ്രവർത്തകർ" }
  ];

  return (
    <><hr/>
    <h1 className='bg-tertiary text-center text-warning fw-normal'>{language === 'en' ? 'We serve' : 'സേവനങ്ങൾ'}</h1>
    <div className="stats-container">
      {stats.map((stat, index) => (
        <div className="stat-card" key={index}>
          <div className="stat-value text-info fw-normal">{stat.value.toLocaleString()}</div>
          <div className="stat-label fs-5 fw-light text-smaller">{language === 'en' ? stat.label : stat.label_ml}</div>
        </div>
      ))}
    </div>
    </>
  );
};

export default AntDesign;